import { useAuth } from '../../contexts/AuthContext';
import { isNative } from '../../lib/platform';
import { openAuthPrompt } from '../../lib/authPrompt';
import { ZeroLogo } from '../layout/ZeroLogo';

export default function MobileWelcome() {
  const { isAuthenticated, isLoading, isDemo } = useAuth();

  if (!isNative) return null;
  if (isLoading) return null;
  if (isAuthenticated || isDemo) return null;

  const tap = async () => {
    try {
      const mod = await import('@capacitor/haptics');
      await mod.Haptics.impact({ style: mod.ImpactStyle.Light });
    } catch {
      /* haptics unavailable — silent */
    }
  };

  const onSignIn = async () => { await tap(); openAuthPrompt('signin'); };
  const onSignUp = async () => { await tap(); openAuthPrompt('signup'); };
  const onDemo = async () => { await tap(); window.location.assign('/demo'); };

  return (
    <div className="mobile-welcome" dir="rtl" role="region" aria-label="مرحباً بك">
      <div className="mobile-welcome-bg" aria-hidden="true" />
      <div className="mobile-welcome-inner">
        <div className="mobile-welcome-logo">
          <ZeroLogo className="h-12 text-pop-fg" />
        </div>
        <h1 className="mobile-welcome-title">أهلًا بك في Zero Merchant</h1>
        <p className="mobile-welcome-sub">
          أدِر متجرك، طلباتك، ومنتجاتك من جهازك في أي وقت.
        </p>
        <div className="mobile-welcome-actions">
          <button type="button" className="mobile-welcome-btn primary" onClick={onSignIn}>
            تسجيل الدخول
          </button>
          <button type="button" className="mobile-welcome-btn secondary" onClick={onSignUp}>
            إنشاء حساب جديد
          </button>
          <button type="button" className="mobile-welcome-demo" onClick={onDemo}>
            تصفح كنسخة تجريبية
          </button>
        </div>
      </div>
      <p className="mobile-welcome-footer">© Zero</p>
    </div>
  );
}
